// Traductions des pages ajoutées (Bientôt disponible, pages légales, réinitialisation)
// + compléments de la modale de connexion. Fusionné (deep-merge) avec translations.js.

const fr = {
  pages: { confidentialite: "Confidentialité", support: "Support", mentions: "Mentions légales", home: "Accueil" },
  comingSoon: {
    createdPrefix: "Ton compte est créé, ",
    title: "Bientôt disponible sur l'App Store et Google Play",
    subtitle: "Rejoins la communauté HitMax. Passionnés de foot, tennis et basket, tous animés par la même règle : décider avec les données, jamais au hasard.",
    appStoreSmall: "Télécharger dans l'", appStore: "App Store",
    playSmall: "Disponible sur", playStore: "Google Play",
    soon: "Bientôt",
    notify: "On te prévient par e-mail dès le lancement.",
    legal: "Le jeu comporte des risques. Interdit aux mineurs.",
    home: "Retour à l'accueil",
  },
  legal: {
    back: "Retour à l'accueil", updated: "Dernière mise à jour : juin 2026.",
    privacy: {
      eyebrow: "Vie privée", title: "Politique de confidentialité",
      intro: "Chez HitMax, la protection de vos données est une priorité. Cette politique explique quelles informations nous collectons, pourquoi, et comment vous gardez le contrôle.",
      h1: "1. Données que nous collectons",
      i1: "Compte : votre nom, votre adresse e-mail et un mot de passe chiffré.",
      i2: "Usage : pages consultées et préférences (langue, matchs suivis).",
      i3: "Nous ne collectons aucune donnée bancaire à la création de compte.",
      h2: "2. Utilisation des données",
      p2: "Vos données servent à créer et sécuriser votre compte, personnaliser vos analyses, et vous prévenir du lancement de l'application mobile. Nous ne revendons jamais vos données à des tiers.",
      h3: "3. Conservation et sécurité",
      p3: "Les mots de passe sont chiffrés (bcrypt) et ne sont jamais stockés en clair. Vos données sont conservées tant que votre compte est actif. Vous pouvez demander leur suppression à tout moment.",
      h4: "4. Vos droits",
      p4a: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'opposition et de suppression de vos données. Pour exercer ces droits, écrivez-nous depuis la page",
      p4link: "Support", p4b: ".",
      h5: "5. Jeu responsable",
      p5: "HitMax est un outil d'analyse et de comparaison. Le jeu comporte des risques : endettement, isolement, dépendance. Interdit aux mineurs.",
    },
    support: {
      eyebrow: "Aide", title: "Support & contact",
      intro: "Une question, un souci technique ou une suggestion ? L'équipe HitMax est là pour vous accompagner.",
      hContact: "Nous contacter",
      emailLabel: "E-mail :", delay: "Délai de réponse : sous 48 heures ouvrées.",
      hFaq: "Questions fréquentes",
      q1: "L'application est-elle déjà disponible ?",
      a1: "Pas encore : elle arrive bientôt sur l'App Store et Google Play. En créant votre compte, vous serez prévenu par e-mail dès le lancement.",
      q2: "Comment modifier ou supprimer mon compte ?",
      a2: "Écrivez-nous à l'adresse ci-dessus et nous traiterons votre demande rapidement.",
      q3: "HitMax permet-il de parier ?",
      a3: "Non. HitMax est un outil d'analyse et de comparaison de cotes. La décision et le risque restent les vôtres.",
      hResp: "Jeu responsable",
      pResp: "Le jeu comporte des risques : endettement, isolement, dépendance. Besoin d'aide ? Appelez le 09 74 75 13 13 (appel non surtaxé). Interdit aux mineurs.",
    },
    mentions: {
      eyebrow: "Informations légales", title: "Mentions légales",
      hEditor: "Éditeur",
      pEditor: "Le site HitMax est édité à des fins de démonstration. Nom commercial : HitMax. Contact : contact@hitmax.io.",
      hHosting: "Hébergement",
      pHosting: "Le site est hébergé sur une infrastructure cloud sécurisée. Les données sont traitées dans le respect de la réglementation en vigueur.",
      hIp: "Propriété intellectuelle",
      pIp: "L'ensemble des éléments du site (textes, logo, visuels, interface) est protégé. Toute reproduction sans autorisation est interdite. Les noms d'équipes et de compétitions cités appartiennent à leurs propriétaires respectifs et sont utilisés à titre illustratif.",
      hData: "Données et analyses",
      pData: "Les probabilités, cotes et analyses présentées sur ce site sont fournies à titre d'illustration (données de démonstration) et ne constituent pas un conseil en pari.",
      hResp: "Responsabilité",
      pResp: "HitMax est un outil d'analyse et de comparaison de cotes. Aucune garantie de résultat n'est fournie. Le jeu comporte des risques : endettement, isolement, dépendance. Interdit aux mineurs.",
    },
  },
  reset: {
    title: "Réinitialiser le mot de passe",
    subtitle: "Choisissez un nouveau mot de passe pour votre compte HitMax.",
    placeholder: "Nouveau mot de passe",
    confirmPlaceholder: "Confirmer le mot de passe",
    submit: "Réinitialiser mon mot de passe",
    loading: "Un instant…",
    mismatch: "Les mots de passe ne correspondent pas.",
    success: "Votre mot de passe a été réinitialisé.",
    successCta: "Se connecter",
    invalidTitle: "Lien invalide ou expiré",
    invalidText: "Ce lien de réinitialisation n'est plus valide. Demandez-en un nouveau depuis la connexion.",
    backHome: "Retour à l'accueil",
  },
  connect: {
    forgotLink: "Mot de passe oublié ?",
    forgotTitle: "Mot de passe oublié",
    forgotSubtitle: "Entrez votre e-mail : nous générons un lien de réinitialisation.",
    forgotSubmit: "Générer le lien",
    forgotBack: "Retour à la connexion",
    forgotSentTitle: "Lien de réinitialisation généré",
    forgotSentNote: "Mode démo : ouvrez ce lien pour choisir un nouveau mot de passe (valable 1 h).",
    forgotOpen: "Ouvrir le lien",
    errors: { TOKEN_INVALID: "Lien invalide ou déjà utilisé.", TOKEN_EXPIRED: "Ce lien a expiré." },
  },
};

const en = {
  pages: { confidentialite: "Privacy", support: "Support", mentions: "Legal notice", home: "Home" },
  comingSoon: {
    createdPrefix: "Your account is created, ",
    title: "Coming soon to the App Store and Google Play",
    subtitle: "Join the HitMax community. Football, tennis and basketball fans, all driven by the same rule: decide with data, never by chance.",
    appStoreSmall: "Download on the", appStore: "App Store",
    playSmall: "Get it on", playStore: "Google Play",
    soon: "Soon",
    notify: "We'll email you as soon as we launch.",
    legal: "Gambling carries risks. Not for minors.",
    home: "Back to home",
  },
  legal: {
    back: "Back to home", updated: "Last updated: June 2026.",
    privacy: {
      eyebrow: "Privacy", title: "Privacy policy",
      intro: "At HitMax, protecting your data is a priority. This policy explains what information we collect, why, and how you stay in control.",
      h1: "1. Data we collect",
      i1: "Account: your name, email address and an encrypted password.",
      i2: "Usage: pages viewed and preferences (language, followed matches).",
      i3: "We collect no banking data when you create an account.",
      h2: "2. How we use your data",
      p2: "Your data is used to create and secure your account, personalize your analyses, and notify you when the mobile app launches. We never sell your data to third parties.",
      h3: "3. Retention and security",
      p3: "Passwords are encrypted (bcrypt) and never stored in plain text. Your data is kept while your account is active. You can request deletion at any time.",
      h4: "4. Your rights",
      p4a: "Under the GDPR, you have the right to access, rectify, object to and delete your data. To exercise these rights, contact us via the",
      p4link: "Support", p4b: " page.",
      h5: "5. Responsible gaming",
      p5: "HitMax is an analysis and comparison tool. Gambling carries risks: debt, isolation, addiction. Not for minors.",
    },
    support: {
      eyebrow: "Help", title: "Support & contact",
      intro: "A question, a technical issue or a suggestion? The HitMax team is here to help.",
      hContact: "Contact us",
      emailLabel: "Email:", delay: "Response time: within 48 business hours.",
      hFaq: "Frequently asked questions",
      q1: "Is the app already available?",
      a1: "Not yet: it's coming soon to the App Store and Google Play. By creating your account, you'll be emailed as soon as we launch.",
      q2: "How do I edit or delete my account?",
      a2: "Email us at the address above and we'll handle your request quickly.",
      q3: "Can I place bets with HitMax?",
      a3: "No. HitMax is an analysis and odds-comparison tool. The decision and the risk remain yours.",
      hResp: "Responsible gaming",
      pResp: "Gambling carries risks: debt, isolation, addiction. Need help? Please reach out to a local support line. Not for minors.",
    },
    mentions: {
      eyebrow: "Legal information", title: "Legal notice",
      hEditor: "Publisher",
      pEditor: "The HitMax website is published for demonstration purposes. Trade name: HitMax. Contact: contact@hitmax.io.",
      hHosting: "Hosting",
      pHosting: "The site is hosted on a secure cloud infrastructure. Data is processed in compliance with applicable regulations.",
      hIp: "Intellectual property",
      pIp: "All elements of the site (text, logo, visuals, interface) are protected. Any reproduction without authorization is prohibited. Team and competition names mentioned belong to their respective owners and are used for illustration.",
      hData: "Data and analyses",
      pData: "The probabilities, odds and analyses shown on this site are provided for illustration (demo data) and do not constitute betting advice.",
      hResp: "Liability",
      pResp: "HitMax is an analysis and odds-comparison tool. No guarantee of results is provided. Gambling carries risks: debt, isolation, addiction. Not for minors.",
    },
  },
  reset: {
    title: "Reset your password",
    subtitle: "Choose a new password for your HitMax account.",
    placeholder: "New password",
    confirmPlaceholder: "Confirm password",
    submit: "Reset my password",
    loading: "One moment…",
    mismatch: "Passwords do not match.",
    success: "Your password has been reset.",
    successCta: "Log in",
    invalidTitle: "Invalid or expired link",
    invalidText: "This reset link is no longer valid. Request a new one from the login screen.",
    backHome: "Back to home",
  },
  connect: {
    forgotLink: "Forgot password?",
    forgotTitle: "Forgot password",
    forgotSubtitle: "Enter your email: we'll generate a reset link.",
    forgotSubmit: "Generate link",
    forgotBack: "Back to login",
    forgotSentTitle: "Reset link generated",
    forgotSentNote: "Demo mode: open this link to choose a new password (valid for 1 hour).",
    forgotOpen: "Open the link",
    errors: { TOKEN_INVALID: "Invalid or already used link.", TOKEN_EXPIRED: "This link has expired." },
  },
};

const es = {
  pages: { confidentialite: "Privacidad", support: "Soporte", mentions: "Aviso legal", home: "Inicio" },
  comingSoon: {
    createdPrefix: "Tu cuenta está creada, ",
    title: "Muy pronto en la App Store y Google Play",
    subtitle: "Únete a la comunidad HitMax. Aficionados al fútbol, tenis y baloncesto, movidos por la misma regla: decidir con datos, nunca al azar.",
    appStoreSmall: "Descargar en la", appStore: "App Store",
    playSmall: "Disponible en", playStore: "Google Play",
    soon: "Pronto",
    notify: "Te avisamos por correo en cuanto lancemos.",
    legal: "El juego conlleva riesgos. Prohibido a menores.",
    home: "Volver al inicio",
  },
  legal: {
    back: "Volver al inicio", updated: "Última actualización: junio de 2026.",
    privacy: {
      eyebrow: "Privacidad", title: "Política de privacidad",
      intro: "En HitMax, proteger tus datos es una prioridad. Esta política explica qué información recopilamos, por qué y cómo mantienes el control.",
      h1: "1. Datos que recopilamos",
      i1: "Cuenta: tu nombre, tu correo electrónico y una contraseña cifrada.",
      i2: "Uso: páginas visitadas y preferencias (idioma, partidos seguidos).",
      i3: "No recopilamos ningún dato bancario al crear la cuenta.",
      h2: "2. Uso de los datos",
      p2: "Tus datos sirven para crear y proteger tu cuenta, personalizar tus análisis y avisarte del lanzamiento de la aplicación móvil. Nunca vendemos tus datos a terceros.",
      h3: "3. Conservación y seguridad",
      p3: "Las contraseñas están cifradas (bcrypt) y nunca se almacenan en texto plano. Tus datos se conservan mientras tu cuenta esté activa. Puedes solicitar su eliminación en cualquier momento.",
      h4: "4. Tus derechos",
      p4a: "Conforme al RGPD, tienes derecho de acceso, rectificación, oposición y supresión de tus datos. Para ejercerlos, escríbenos desde la página de",
      p4link: "Soporte", p4b: ".",
      h5: "5. Juego responsable",
      p5: "HitMax es una herramienta de análisis y comparación. El juego conlleva riesgos: endeudamiento, aislamiento, adicción. Prohibido a menores.",
    },
    support: {
      eyebrow: "Ayuda", title: "Soporte y contacto",
      intro: "¿Una pregunta, un problema técnico o una sugerencia? El equipo de HitMax está aquí para ayudarte.",
      hContact: "Contáctanos",
      emailLabel: "Correo:", delay: "Tiempo de respuesta: en 48 horas laborables.",
      hFaq: "Preguntas frecuentes",
      q1: "¿La aplicación ya está disponible?",
      a1: "Todavía no: llega muy pronto a la App Store y Google Play. Al crear tu cuenta, te avisaremos por correo en cuanto lancemos.",
      q2: "¿Cómo modifico o elimino mi cuenta?",
      a2: "Escríbenos a la dirección anterior y gestionaremos tu solicitud rápidamente.",
      q3: "¿Puedo apostar con HitMax?",
      a3: "No. HitMax es una herramienta de análisis y comparación de cuotas. La decisión y el riesgo son tuyos.",
      hResp: "Juego responsable",
      pResp: "El juego conlleva riesgos: endeudamiento, aislamiento, adicción. ¿Necesitas ayuda? Contacta con una línea de apoyo local. Prohibido a menores.",
    },
    mentions: {
      eyebrow: "Información legal", title: "Aviso legal",
      hEditor: "Editor",
      pEditor: "El sitio HitMax se publica con fines de demostración. Nombre comercial: HitMax. Contacto: contact@hitmax.io.",
      hHosting: "Alojamiento",
      pHosting: "El sitio está alojado en una infraestructura en la nube segura. Los datos se tratan conforme a la normativa vigente.",
      hIp: "Propiedad intelectual",
      pIp: "Todos los elementos del sitio (textos, logotipo, imágenes, interfaz) están protegidos. Queda prohibida cualquier reproducción sin autorización. Los nombres de equipos y competiciones citados pertenecen a sus respectivos propietarios y se usan a título ilustrativo.",
      hData: "Datos y análisis",
      pData: "Las probabilidades, cuotas y análisis mostrados en este sitio se ofrecen a título ilustrativo (datos de demostración) y no constituyen un consejo de apuestas.",
      hResp: "Responsabilidad",
      pResp: "HitMax es una herramienta de análisis y comparación de cuotas. No se ofrece ninguna garantía de resultados. El juego conlleva riesgos: endeudamiento, aislamiento, adicción. Prohibido a menores.",
    },
  },
  reset: {
    title: "Restablecer la contraseña",
    subtitle: "Elige una nueva contraseña para tu cuenta HitMax.",
    placeholder: "Nueva contraseña",
    confirmPlaceholder: "Confirmar contraseña",
    submit: "Restablecer mi contraseña",
    loading: "Un momento…",
    mismatch: "Las contraseñas no coinciden.",
    success: "Tu contraseña se ha restablecido.",
    successCta: "Iniciar sesión",
    invalidTitle: "Enlace no válido o caducado",
    invalidText: "Este enlace de restablecimiento ya no es válido. Solicita uno nuevo desde el inicio de sesión.",
    backHome: "Volver al inicio",
  },
  connect: {
    forgotLink: "¿Contraseña olvidada?",
    forgotTitle: "Contraseña olvidada",
    forgotSubtitle: "Introduce tu correo: generaremos un enlace de restablecimiento.",
    forgotSubmit: "Generar enlace",
    forgotBack: "Volver al inicio de sesión",
    forgotSentTitle: "Enlace de restablecimiento generado",
    forgotSentNote: "Modo demo: abre este enlace para elegir una nueva contraseña (válido 1 h).",
    forgotOpen: "Abrir el enlace",
    errors: { TOKEN_INVALID: "Enlace no válido o ya usado.", TOKEN_EXPIRED: "Este enlace ha caducado." },
  },
};

export const extra = { fr, en, es };
export default extra;
